import { cn } from '@/lib/utils';

export default function H1({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h1 className={cn('text-h3 font-medium lg:text-h1 lg:font-normal', className)}>{children}</h1>;
}
